import moment from "moment";
import {
  listFields,
  ListFieldsKeys,
  ListFieldsType,
} from "../../../api/config";
import _ from "lodash";
import { FIELDS_TYPES } from "src/api/config/type.config";

import { strapiUrl } from "src/modules/users/constants";
import axios from "axios";
import { listMap } from "src/api/config/systemSwitch";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";
import {
  prepareAddedWorkstationUsersContext,
  syncWorkstationNewUsersFamiliarization,
} from "./syncWorkstationNewUsersFamiliarization";

export type AddItemRequestProps<K extends ListFieldsKeys> = {
  listName: K;
  body: Partial<Record<keyof ListFieldsType[K], any>>;
  updateReducer?: boolean;
  bodyArr?: Partial<Record<keyof ListFieldsType[K], any>>[];
  anySite?: string;
};

export const addItemRequest = <K extends ListFieldsKeys>({
  listName,
  body,
  bodyArr,
  anySite,
}: AddItemRequestProps<K>) => {
  const fields = listFields[listName];
  const listStrapiApi = listMap[listName].replace(":folder", "");
  let addObj: Record<string, any> = {};
  let addArr: any = [];
  let emails: string[] = [];
  if (bodyArr && bodyArr.length > 0) {
    bodyArr.forEach((item: any) => {
      let strapiObjData: any = {};
      Object.keys(item).forEach((key) => {
        switch (key) {
          case "Type5Way":
            strapiObjData["Type5Why"] = item[key];
            break;
          case "Date5Way":
            strapiObjData["Date5Why"] = item[key];
            break;
          case "Region":
            strapiObjData["Area"] = item[key];
            break;
          case "Departament":
            strapiObjData["Department"] = item[key];
            break;
          case "_x0035_Way":
            strapiObjData["FiveWhy"] = item[key];
            break;
          case "KPI":
            strapiObjData["Kpi"] = item[key];
            break;
          case "Status":
            strapiObjData["CardStatus"] = item[key];
            break;
          case "Sector":
            strapiObjData["Column"] = item[key];
            break;
          case "Process":
            strapiObjData["ColumnBlockArea"] = item[key];
            break;
          case "DocumentID":
            strapiObjData["IDDocument"] = item[key];
            break;
          default:
            strapiObjData[key] = item[key];
            break;
        }
      });
      let addObjinArr: Record<string, any> = {};
      Object.keys(strapiObjData).forEach((fieldKey) => {
        const key = fieldKey as keyof typeof strapiObjData;
        const value = strapiObjData[key];
        const fieldType = fields[key as keyof typeof fields];

        switch (fieldType) {
          case FIELDS_TYPES.DATE:
            if (_.isDate(value)) {
              let dateField = moment(value).toISOString();
              addObjinArr = { ...addObjinArr, [key]: dateField };
            } else if (typeof value === "string") {
              addObjinArr = { ...addObjinArr, [key]: value };
            }
            break;
          case FIELDS_TYPES.ID:
            break;
          case FIELDS_TYPES.BOOLEAN:
            addObjinArr = { ...addObjinArr, [key]: value ? true : false };
            break;
          case FIELDS_TYPES.USER:
            emails = [...emails, value];
            addObjinArr = { ...addObjinArr, [key]: value };
            break;
          case FIELDS_TYPES.MULTI_USER:
            emails = [...emails, ...value];
            addObjinArr = { ...addObjinArr, [key]: value };
            break;
          default:
            addObjinArr = { ...addObjinArr, [key]: value };
            break;
        }
      });
      addArr = [...addArr, addObjinArr];
    });
  } else {
    let strapiObjData: any = {};
    const bodyRecord = body as Record<string, any>;
    Object.keys(bodyRecord).forEach((key) => {
      switch (key) {
        case "Type5Way":
          strapiObjData["Type5Why"] = bodyRecord[key];
          break;
        case "Date5Way":
          strapiObjData["Date5Why"] = bodyRecord[key];
          break;
        case "Region":
          strapiObjData["Area"] = bodyRecord[key];
          break;
        case "Departament":
          strapiObjData["Department"] = body[key];
          break;
        case "_x0035_Way":
          strapiObjData["FiveWhy"] = bodyRecord[key];
          break;
        case "KPI":
          strapiObjData["Kpi"] = bodyRecord[key];
          break;
        case "Status":
          strapiObjData["CardStatus"] = bodyRecord[key];
          break;
        case "Sector":
          strapiObjData["Column"] = bodyRecord[key];
          break;
        case "Process":
          strapiObjData["ColumnBlockArea"] = bodyRecord[key];
          break;
        case "DocumentID":
          strapiObjData["IDDocument"] = bodyRecord[key];
          break;
        default:
          strapiObjData[key] = bodyRecord[key];
          break;
      }
    });
    Object.keys(strapiObjData).forEach((fieldKey) => {
      const key = fieldKey as keyof typeof strapiObjData;
      const value = strapiObjData[key];
      const fieldType = fields[key as keyof typeof fields];
      switch (fieldType) {
        case FIELDS_TYPES.DATE:
          if (_.isDate(value)) {
            let dateField = moment(value).toISOString();
            addObj = { ...addObj, [key]: dateField };
          } else if (typeof value === "string") {
            addObj = { ...addObj, [key]: value };
          }
          break;
        case FIELDS_TYPES.ID:
          break;
        case FIELDS_TYPES.BOOLEAN:
          addObj = { ...addObj, [key]: value ? true : false };
          break;
        case FIELDS_TYPES.USER:
          addObj = { ...addObj, [key]: value };
          emails = [...emails, value];
          break;
        case FIELDS_TYPES.MULTI_USER:
          addObj = { ...addObj, [key]: value };
          emails = [...emails, ...value];
          break;
        default:
          addObj = { ...addObj, [key]: value };
          break;
      }
    });
  }

  return new Promise(async (resolve, reject) => {
    let token: string | null = null;

    if (!isPWA()) {
      const result = await SecureStoragePlugin.get({ key: 'accessToken' });
      token = result.value;
    }

    const headers = {
      Accept: "application/json;odata=nometadata",
      "Content-Type": "application/json;odata=nometadata",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const runWorkstationPostAddHook = (createdIds: number[], resolveValue: number) => {
      const contexts = prepareAddedWorkstationUsersContext({
        listName,
        body,
        bodyArr,
        createdIds,
      });

      Promise.resolve(syncWorkstationNewUsersFamiliarization(contexts))
        .catch((error) => console.error("syncWorkstationNewUsersFamiliarization", error))
        .finally(() => resolve(resolveValue));
    };

    if (addArr.length > 0) {
      if (emails.length > 0) {
        let sendAddArr: Record<string, any>[] = [];
        const query = [..._.uniqWith(emails, _.isEqual)]
          .filter((e) => e && e !== "undefined" && e !== "null")
          .map((e) => `filters[email][$in]=${e}`)
          .join("&");
        axios
          .get(`${strapiUrl}users?${query}`, {
            headers,
            withCredentials: true,
          })
          .then((users) => {
            addArr.forEach((data: Record<string, any>) => {
              let sendAddObj: Record<string, any> = {};
              Object.keys(data).forEach((key) => {
                if (data[key]) {
                  const fieldType = fields[key as keyof typeof fields];
                  switch (fieldType) {
                    case FIELDS_TYPES.USER:
                      if (data[key]) {
                        sendAddObj = {
                          ...sendAddObj,
                          [key]: users.data.find(
                            (u: { email: string; id: number }) =>
                              data[key] === u.email
                          )["id"],
                        };
                      }
                      break;
                    case FIELDS_TYPES.MULTI_USER:
                      sendAddObj = {
                        ...sendAddObj,
                        [key]: users.data
                          .filter((u: { email: string; id: number }) =>
                            data[key].some((email: string) => email === u.email)
                          )
                          .map((u: { email: string; id: number }) => u.id),
                      };
                      break;
                    default:
                      sendAddObj = { ...sendAddObj, [key]: data[key] };
                      break;
                  }
                }
              });
              sendAddArr = [...sendAddArr, sendAddObj];
            });
            let requests: any = [];
            sendAddArr.forEach((item) => {
              requests = [
                ...requests,
                axios.post(
                  `${strapiUrl}${listStrapiApi}`,
                  { data: item },
                  {
                    headers,
                    withCredentials: true
                  }
                ),
              ];
            });
            Promise.all(requests)
              .then((values) => {
                console.log("RESULT_MULTI_ADD_STRAPI: ", values);
                const createdIds = values.map((value) => value.data.data["id"]);
                runWorkstationPostAddHook(createdIds, createdIds[0]);
              })
              .catch(reject);
          })
          .catch(reject);
      } else {
        let requests: any = [];
        addArr.forEach((item: any) => {
          requests = [
            ...requests,
            axios.post(
              `${strapiUrl}${listStrapiApi}`,
              { data: item },
              {
                headers,
                withCredentials: true
              }
            ),
          ];
        });
        Promise.all(requests)
          .then((values) => {
            console.log("RESULT_MULTI_ADD_STRAPI: ", values);
            const createdIds = values.map((value) => value.data.data["id"]);
            runWorkstationPostAddHook(createdIds, createdIds[0]);
          })
          .catch(reject);
      }
    } else {
      if (emails.length > 0) {
        const query = [..._.uniqWith(emails, _.isEqual)]
          .filter((e) => e && e !== "undefined" && e !== "null")
          .map((e) => `filters[email][$in]=${e}`)
          .join("&");
        axios
          .get(`${strapiUrl}users?${query}`, {
            headers,
            withCredentials: true,
          })
          .then((users) => {
            let sendAddObj: Record<string, any> = {};
            Object.keys(addObj).forEach((key) => {
              if (addObj[key]) {
                const fieldType = fields[key as keyof typeof fields];
                switch (fieldType) {
                  case FIELDS_TYPES.USER:
                    if (addObj[key]) {
                      sendAddObj = {
                        ...sendAddObj,
                        [key]: users.data.find(
                          (u: { email: string; id: number }) =>
                            addObj[key] === u.email
                        )["id"],
                      };
                    }
                    break;
                  case FIELDS_TYPES.MULTI_USER:
                    sendAddObj = {
                      ...sendAddObj,
                      [key]: users.data
                        .filter((u: { email: string; id: number }) =>
                          addObj[key].some((email: string) => email === u.email)
                        )
                        .map((u: { email: string; id: number }) => u.id),
                    };
                    break;
                  default:
                    sendAddObj = { ...sendAddObj, [key]: addObj[key] };
                    break;
                }
              }
            });
            axios
              .post(
                `${strapiUrl}${listStrapiApi}`,
                {
                  data: sendAddObj,
                },
                {
                  headers,
                  withCredentials: true,
                }
              )
              .then((res) => {
                console.log("RESULT_SINGLE_ADD_STRAPI: ", res);
                runWorkstationPostAddHook([res.data.data["id"]], res.data.data["id"]);
              })
              .catch(reject);
          })
          .catch(reject);
      } else {
        axios
          .post(
            `${strapiUrl}${listStrapiApi}`,
            {
              data: addObj,
            },
            {
              headers,
              withCredentials: true,
            }
          )
          .then((res) => {
            console.log("RESULT_SINGLE_ADD_STRAPI: ", res);
            runWorkstationPostAddHook([res.data.data["id"]], res.data.data["id"]);
          })
          .catch((err) => reject(err));
      }
    }
  });
};
